import { Box, Flex } from '@chakra-ui/react';

import { Shimmer } from 'components/Shimmer';
import { neutral, radius } from 'styles/revampTokens';

/**
 * Shaped like the saved-models grid — thumbnail, name, created date, block
 * count strip — so the page fills in rather than swapping out from under the
 * reader. Replaces a full-viewport spinner on a violet wash.
 */
const CARD_COUNT = 8;

const ModelsGridSkeleton = () => (
  <Box px='2.5vw' py='30px' bg={neutral.surface} role='status' aria-label='Loading models'>
    <Shimmer height='26px' width='260px' mb='14px' />
    <Shimmer height='12px' width='520px' maxW='80%' mb='40px' />

    <Flex align='center' justify='space-between' mb='24px'>
      <Flex align='center' gap='16px'>
        <Shimmer height='14px' width='170px' />
        <Shimmer height='36px' width='280px' borderRadius='18px' />
      </Flex>
      <Shimmer height='44px' width='160px' borderRadius='22px' />
    </Flex>

    <Flex wrap='wrap' gap='24px'>
      {Array.from({ length: CARD_COUNT }).map((_, index) => (
        <Box
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          flex='1 1 260px'
          maxW='340px'
          border={`1px solid ${neutral.border}`}
          borderRadius={radius.surface}
          overflow='hidden'
        >
          <Shimmer height='150px' borderRadius='0' />
          <Box p='14px'>
            <Shimmer height='11px' width='75%' mb='10px' />
            <Shimmer height='9px' width='45%' />
          </Box>
          <Flex
            align='center'
            justify='space-between'
            px='14px'
            py='12px'
            borderTop={`1px solid ${neutral.borderSubtle}`}
          >
            <Shimmer height='9px' width='64px' />
            <Shimmer height='9px' width='96px' />
          </Flex>
        </Box>
      ))}
    </Flex>
  </Box>
);

export default ModelsGridSkeleton;
